module.exports = __webpack_public_path__ + "img/bg_main08_mask.f9509ba1.svg";